var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { AreaSubject } from '@/models/AreaSubject';
import { generateUuid } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard.vue';
let SubjectLevelSelector = class SubjectLevelSelector extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        // protected groupClone: Group = {} as Group;
        this.selectedAll = false;
        this.selectedSubjects = [];
        // protected searchInput = '';
        // protected searchDebounce = this.handleSearch();
        this.isLoading = true;
        this.areaSubjects = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // protected mounted(): void {
    //   this.initialize();
    // }
    // protected async initialize(): Promise<void> {
    //   this.isLoading = true;
    //   this.groupClone = cloneDeep(this.group);
    //   this.isLoading = false;
    // }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        // const body = document.querySelectorAll('body')[0];
        // addClass(body, 'bodyNoScroll');
        await this.fetchSubjects();
        this.isLoading = false;
    }
    async fetchSubjects() {
        try {
            const response = await new AreaSubject()
                .group(this.group.id)
                .all();
            this.areaSubjects = response.subjects;
            this.areaSubjects.forEach(areaSubject => {
                if (areaSubject.groups) {
                    areaSubject.groups.map(group => {
                        group.id === generateUuid();
                    });
                }
                if (areaSubject.periods) {
                    areaSubject.periods.map(period => {
                        period.id === generateUuid();
                    });
                }
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onSelectedSubjectsChange(value) {
        this.$emit('update:selectedSubjects', value);
    }
    onselectedAllChange(value) {
        this.$emit('onSelectedAll', value);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], SubjectLevelSelector.prototype, "group", void 0);
__decorate([
    Watch('selectedSubjects', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], SubjectLevelSelector.prototype, "onSelectedSubjectsChange", null);
__decorate([
    Watch('selectedAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SubjectLevelSelector.prototype, "onselectedAllChange", null);
SubjectLevelSelector = __decorate([
    Component({
        components: {
            LoaderCard
        }
    })
], SubjectLevelSelector);
export default SubjectLevelSelector;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
